import React from "react";
import "../../Component/Loading/Loading.css";

export default function Loading() {
  return (
    <div className="position-relative loading">
      <div className="loadingio-spinner-spinner-dleajeu6vn7 position-absolute start-50 top-50 translate-middle-x">
        <div className="ldio-vifnae9pvv">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
